import { render, staticRenderFns } from "./footer-verpackung.vue?vue&type=template&id=79736642"
import script from "./footer-verpackung.vue?vue&type=script&lang=js"
export * from "./footer-verpackung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports